import React from 'react';
import { useTranslation } from 'react-i18next';
import '../cpdpro.css';

export default function CpdProWaaromPage() {
  const { t } = useTranslation();

  return (
    <>
      <section className="cpd-page-hero">
        <div className="container">
          <h1>{t('cpd.why.title', 'Waarom CPD Pro?')}</h1>
          <p className="muted">{t('cpd.why.subtitle', 'What makes CPD Pro the easiest way to stay compliant and progress.')}</p>
        </div>
      </section>

      <section className="cpd-features">
        <div className="container">
          <h2>{t('features.title', 'Everything You Need for Your Professional Growth')}</h2>
          <div className="features-grid">
            <div className="feature-card">
              <h4>{t('features.earnGlobally.title', 'Earn CPD Points Globally')}</h4>
              <p>{t('features.earnGlobally.desc', 'Earn officially recognized CPD points from anywhere in the world.')}</p>
            </div>
            <div className="feature-card">
              <h4>{t('features.readLearn.title', 'Read & Learn with Purpose')}</h4>
              <p>{t('features.readLearn.desc', 'Access curated, high-quality articles while you earn CPD points.')}</p>
            </div>
            <div className="feature-card">
              <h4>{t('features.quickTests.title', 'Quick Knowledge Tests')}</h4>
              <p>{t('features.quickTests.desc', 'Take short, AI-generated tests (5 questions max) and unlock certificates instantly.')}</p>
            </div>
            <div className="feature-card">
              <h4>{t('features.trackDownload.title', 'Track & Download Certificates')}</h4>
              <p>{t('features.trackDownload.desc', 'Automatically generate and store your accredited certificates. Download anytime.')}</p>
            </div>
          </div>
        </div>
      </section>

      <section className="cpd-how-it-works">
        <div className="container">
          <h2>{t('how.title', 'Get Certified in 3 Simple Steps')}</h2>
          <div className="steps-container">
            <div className="step">
              <div className="step-icon">1</div>
              <h3>{t('how.step1.title', 'Browse Articles')}</h3>
              <p>{t('how.step1.desc', 'Choose content that fits your profession and goals.')}</p>
            </div>
            <div className="step-arrow">→</div>
            <div className="step">
              <div className="step-icon">2</div>
              <h3>{t('how.step2.title', 'Take the Test')}</h3>
              <p>{t('how.step2.desc', 'Pass a short multiple-choice test (max 5 questions).')}</p>
            </div>
            <div className="step-arrow">→</div>
            <div className="step">
              <div className="step-icon">3</div>
              <h3>{t('how.step3.title', 'Earn Your Certificate')}</h3>
              <p>{t('how.step3.desc', 'Download your certificate instantly and keep your history for audits.')}</p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}


